import { RISK_PRIORITY } from '@features/regional-overview/regional-overview.constants';
import type { RegionalOverviewV2Properties, RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';

export const sortFieldsByRiskFarmAndName = (a: RegionalOverviewV2Properties, b: RegionalOverviewV2Properties): number => {
  const riskA = a.calculatedRisk as RiskLevelEnum;
  const riskB = b.calculatedRisk as RiskLevelEnum;
  const riskComparison = RISK_PRIORITY[riskB] - RISK_PRIORITY[riskA];

  const hasDifferentRisk = riskComparison !== 0;
  if (hasDifferentRisk) return riskComparison;

  const farmNameA = a.values?.property_name ?? '';
  const farmNameB = b.values?.property_name ?? '';
  const farmNameComparison = farmNameA.localeCompare(farmNameB, 'en', { numeric: true });

  const hasDifferentFarmName = farmNameComparison !== 0;
  if (hasDifferentFarmName) return farmNameComparison;

  const fieldNameA = a.name ?? '';
  const fieldNameB = b.name ?? '';
  return fieldNameA.localeCompare(fieldNameB, 'en', { numeric: true });
};
